import { createSelector } from 'reselect';
import CarditCriticalElementsDetailsColumns from '../../containers/CarditCriticalElementsDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.CARDIT_CRITICAL_ELEMENTS_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_CRITICAL_ELEMENTS_DETAILS.isLoading;

export const getData =
  ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, CarditCriticalElementsDetailsColumns);
